import React from "react";

/** Labelled row inside the mobile filters sheet. */
const FilterField: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="space-y-2">
    <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">{label}</p>
    {children}
  </div>
);

export default FilterField;
